import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const CreateImageService = (data: FormData) => {
  return HTTP_CLIENT.post(`${Endpoint.image.addImage}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
const GetAllImagesService = () => {
  return HTTP_CLIENT.get(`${Endpoint.image.getImages}`);
};

const DeleteImageService = (id: number) => {
  return HTTP_CLIENT.delete(`${Endpoint.image.deleteImage}/${id}`);
};

const UpdateImageService = (id: number, data: FormData) => {
  return HTTP_CLIENT.patch(`${Endpoint.image.updateImage}/${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export {
  CreateImageService,
  GetAllImagesService,
  DeleteImageService,
  UpdateImageService,
};
